<div [formGroup]="parentForm" id="extra-prompts-container"  *ngIf="!(formState$ | async)?.loading">
    <mm-sa-ach-transfer-direction 
      [parentForm]="extraPromptsGroup" 
      [instructions$]="instructions$" 
      class="big-bottom-spacer">
    </mm-sa-ach-transfer-direction>
    <mm-sa-ach-source-of-funds *ngIf="showTargetOfFunds || isFromEditSubmittedStandingAuth"
      [parentForm]="extraPromptsGroup"
      [instructions$]="instructions$"
      [directionSelection$]="directionSelection$"
      class="big-bottom-spacer">
    </mm-sa-ach-source-of-funds>
    <mm-radio-control *ngIf="isFromEditSubmittedStandingAuth" [parentForm]="extraPromptsGroup"
    [radioModel]="frequencySelectorModel" class="big-bottom-spacer" data-testid="frequencyControl">
  </mm-radio-control>
  </div>